import React, { useEffect, useState } from "react";
import { Table, Button, Container } from "react-bootstrap";
import { api, getStaticData, sortArrayOfObjects } from "../pureFunctions";
import * as XLSX from "xlsx";

const TABLE_HEADERS = {
   KdNr: "KdNr",
   Name: "Name",
   Vorname: "Vorname",
   Eintragsdatum: "Startdatum",
   ind_3548_Feld_adressen124: "BUWOG-Kontaktdatum",
   //    ind_3080_Feld_adressen93: "Anrufanzahl",
   ind_3450_Feld_adressen114: "Aktueller Stand der Beratungen",
   //    ind_2928_Feld_adressen82: "Letzter Anruf",
   ind_3452_Feld_adressen115: "Absagegrund",
};

let initialAddressParameters = {
   data: [
      "KdNr",
      "ind_3082_Feld_adressen94", //Personenanzahl
      "ind_3070_Feld_adressen88", //Veranstaltungsdatum,
      "ind_3084_Feld_adressen95", //Leadverlauf
      "Name",
      "Vorname",
      "Benutzer",
      "ind_3094_Feld_adressen99", //zuständigkeit
      "ind_2576_Feld_adressen73", //Akquisestufe
      "Letzte_Aktion",
      "ind_2928_Feld_adressen82", //letzter Anruf
      "ind_3080_Feld_adressen93", //Anrufanzahl
      "ind_2586_Feld_adressen78", //Wunschzeitraum
      "ind_2582_Feld_adressen73", //"Rückfragedatum",
      "ind_3450_Feld_adressen114", //buwog status,
      "ind_3548_Feld_adressen124", //buwog startdatum
      "ind_3452_Feld_adressen115", //absagegrund
      "Eintragsdatum",
   ],
   filter: {
      //   ind_3448_Feld_adressen113: [{ op: "=", val: "1" }], //ist buwog-Kontakt
      HerkunftKontakt: [{ op: "IN", val: ["indMulti3446Select8052"] }], //herkungt buwog
   },
   listlimit: 500,
   sortby: "KdNr",
   sortorder: "DESC",
};

function escapeCsvValue(value) {
   const stringValue = String(value ?? "");
   if (/[",;\n]/.test(stringValue)) {
      return `"${stringValue.replace(/"/g, '""')}"`;
   }
   return stringValue;
}

function buildCsv(leads, fieldConfiguration) {
   let csv_headers = structuredClone(TABLE_HEADERS);
   //    delete csv_headers.KdNr;
   const rows = leads.map((lead, index) =>
      Object.keys(csv_headers).map(
         (headerKey) => fieldConfiguration?.address?.[headerKey]?.permittedvalues?.[lead[headerKey]] ?? lead[headerKey],
      ),
   );

   const lines = [Object.values(csv_headers), ...rows].map((row) => row.map(escapeCsvValue).join(";"));

   // BOM voranstellen, damit Umlaute in Excel korrekt angezeigt werden
   return "\uFEFF" + lines.join("\r\n");
}

function downloadCsv(csvContent, filename) {
   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
   const url = URL.createObjectURL(blob);
   const link = document.createElement("a");
   link.href = url;
   link.setAttribute("download", filename);
   document.body.appendChild(link);
   link.click();
   document.body.removeChild(link);
   URL.revokeObjectURL(url);
}

function buildExcelWorkbook(leads, fieldConfiguration) {
   let headers = structuredClone(TABLE_HEADERS);
   //    delete headers.KdNr;

   const headerLabels = Object.values(headers);
   const headerKeys = Object.keys(headers);

   const rows = leads.map((lead) =>
      headerKeys.map(
         (headerKey) => fieldConfiguration?.address?.[headerKey]?.permittedvalues?.[lead[headerKey]] ?? lead[headerKey],
      ),
   );

   // Erste Zeile: Gesamtanzahl, dann eine Leerzeile, dann Header + Daten
   const aoa = [[`Gesamtanzahl Kontakte: ${leads.length}`], [], headerLabels, ...rows];

   const worksheet = XLSX.utils.aoa_to_sheet(aoa);

   // Titelzeile über die gesamte Tabellenbreite verschmelzen
   worksheet["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headerLabels.length - 1 } }];

   // Optional: Spaltenbreiten etwas großzügiger setzen
   worksheet["!cols"] = headerLabels.map(() => ({ wch: 20 }));

   const workbook = XLSX.utils.book_new();
   XLSX.utils.book_append_sheet(workbook, worksheet, "Buwog Leads");

   return workbook;
}

function downloadExcel(workbook, filename) {
   XLSX.writeFile(workbook, filename);
}

export default function BuwogLeads({}) {
   const [visitors, setVisitors] = useState([]);
   const [sortKey, setSortKey] = useState("");
   const [fieldConfiguration, setFieldConfiguration] = useState();
   const [sortDirection, setSortDirection] = useState(1);

   async function loadAllData() {
      let [newestatekacheln, cleanUserData, newfieldConfiguration] = await getStaticData();
      //   setAllKacheln(newestatekacheln);
      setFieldConfiguration(newfieldConfiguration);
      //   setUserObjects(cleanUserData.userObject);

      let notFullyLoaded = true;
      let i = 0;

      let addressParameters = structuredClone(initialAddressParameters);
      console.log(addressParameters);

      do {
         addressParameters.listoffset = 500 * i;

         await api
            .post("/api/getfilteredaddresses", { parameters: addressParameters })
            .then((data) => {
               console.log(data);

               const adressdata = data.data.map((item, index) => {
                  return {
                     ...item["elements"],
                     index: index,
                     Eintragsdatum: item?.elements?.Eintragsdatum?.slice(0, 10),
                  };
               });
               console.log(data);
               console.log(data.data.length);
               if (data.data.length < 500) {
                  notFullyLoaded = false;
               }

               setVisitors((prev) => [...prev, ...adressdata]);
               i++;
            })
            .catch((err) => {
               console.log(err);
               i = 500;
            });
      } while (notFullyLoaded);

      // setFullLoaded(true);
   }

   useEffect(() => {
      loadAllData();
   }, []);

   const handleExport = () => {
      const csv = buildCsv(visitors, fieldConfiguration);
      const today = new Date().toISOString().slice(0, 10);
      downloadCsv(csv, `buwog-leads-${today}.csv`);
   };

   const handleExcelExport = () => {
      const workbook = buildExcelWorkbook(visitors, fieldConfiguration);
      const today = new Date().toISOString().slice(0, 10);
      downloadExcel(workbook, `buwog-leads-${today}.xlsx`);
   };

   return (
      <div className="m-5 py-4">
         <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="mb-0">Buwog Leads</h2>
            <div className="d-flex gap-2">
               <Button variant="primary" onClick={handleExport}>
                  Als CSV herunterladen
               </Button>
               <Button variant="success" onClick={handleExcelExport}>
                  Als Excel herunterladen
               </Button>
            </div>
         </div>
         <Table striped bordered hover responsive>
            <thead>
               <tr>
                  <th>Index</th>
                  {Object.keys(TABLE_HEADERS).map((headerKey) => {
                     return (
                        <th
                           style={{
                              ...(sortKey === headerKey ? { outline: "solid 6px #0008", outlineOffset: "-6px" } : {}),
                           }}
                           onClick={() => {
                              console.log(headerKey);

                              setVisitors(sortArrayOfObjects(visitors, headerKey, sortDirection));
                              setSortDirection((prev) => prev * -1);
                              setSortKey(headerKey);
                           }}
                        >
                           {TABLE_HEADERS[headerKey]}
                           {sortKey === headerKey && <span>{sortDirection > 0 ? "▲" : "▼"}</span>}
                        </th>
                     );
                  })}
               </tr>
            </thead>
            <tbody>
               {visitors?.map((lead, index) => (
                  <tr key={index}>
                     <td>{index + 1}</td>
                     {Object.keys(TABLE_HEADERS).map((headerKey) => {
                        return (
                           <th>
                              {fieldConfiguration?.address?.[headerKey]?.permittedvalues?.[lead[headerKey]] ??
                                 lead[headerKey]}
                           </th>
                        );
                     })}
                  </tr>
               ))}
            </tbody>
         </Table>
      </div>
   );
}
